export const IMAGES = [
    {
      id: 1,
      img: "/assets/images/image-waffle-desktop.jpg",
      name: " Waffle",
      discription: "Waffle with Berries",
      price: 6.5,
      count: 1,
    },
    {
      id: 2,
      img: "/assets/images/image-creme-brulee-desktop.jpg",
      name: "  Crème Brûlée",
      discription: "Vanilla Bean Crème Brûlée",
      price: 7.0,
      count: 1,
    },
    {
      id: 3,
      img: "/assets/images/image-macaron-desktop.jpg",
      name: " Macaron",
      discription: " Macaron Mix of Five",
      price: 8.0,
      count: 1,
    },
    {
      id: 4,
      img: "/assets/images/image-tiramisu-desktop.jpg",
      name: "  Tiramisu",
      discription: " Classic Tiramisu",
      price: 5.5,
      count: 1,
    },
    {
      id: 5,
      img: "/assets/images/image-baklava-desktop.jpg",
      name: "  Baklava",
      discription: " Pistachio Baklava",
      price: 4.0,
      count: 1,
    },
    {
      id: 6,
      img: "/assets/images/image-meringue-desktop.jpg",
      name: "Pie",
      discription: " Lemon Meringue Pie",
      price: 5.0,
      count: 1,
    },
    {
      id: 7,
      img: "/assets/images/image-cake-desktop.jpg",
      name: " Cake",
      discription: " Red Velvet Cake",
      price: 4.5,
      count: 1,
    },
    {
      id: 8,
      img: "/assets/images/image-brownie-desktop.jpg",
      name: " Brownie",
      discription: " Salted Caramel Brownie",
      price: 4.5,
      count: 1,
    },
    {
      id: 9,
      img: "/assets/images/image-panna-cotta-desktop.jpg",
      name: " Panna Cotta",
      discription: "Vanilla Panna Cotta",
      price: 6.5,
      count: 1,
    },
  ];
